import { render, staticRenderFns } from "./BaseIcon.vue?vue&type=template&id=a3044b8e&scoped=true&lang=pug&"
import script from "./BaseIcon.vue?vue&type=script&lang=ts&"
export * from "./BaseIcon.vue?vue&type=script&lang=ts&"
import style0 from "./BaseIcon.vue?vue&type=style&index=0&id=a3044b8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3044b8e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\as3-portals\\AS3.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a3044b8e')) {
      api.createRecord('a3044b8e', component.options)
    } else {
      api.reload('a3044b8e', component.options)
    }
    module.hot.accept("./BaseIcon.vue?vue&type=template&id=a3044b8e&scoped=true&lang=pug&", function () {
      api.rerender('a3044b8e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/components/BaseIcon.vue"
export default component.exports